import React from 'react';

const IconWebPage = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    viewBox="0 0 64 64"
    fill="currentColor"
    stroke="none"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-web-page">
    <title>WebPage</title>
    <path
      fill="currentColor"
      d="m57 2h-50a5.006 5.006 0 0 0 -5 5v50a5.006 5.006 0 0 0 5 5h50a5.006 5.006 0 0 0 5-5v-50a5.006 5.006 0 0 0 -5-5zm-50 2h50a3 3 0 0 1 3 3v3h-56v-3a3 3 0 0 1 3-3zm50 56h-50a3 3 0 0 1 -3-3v-45h56v45a3 3 0 0 1 -3 3z"
    />
    <path fill="currentColor" d="m6 6h2v2h-2z" />
    <path fill="currentColor" d="m10 6h2v2h-2z" />
    <path fill="currentColor" d="m14 6h2v2h-2z" />
    <path fill="currentColor" d="m6 30h52v-16h-52zm2-14h48v12h-48z" />
    <path fill="currentColor" d="m6 58h16v-26h-16zm2-24h12v22h-12z" />
    <path fill="currentColor" d="m24 44h34v-12h-34zm2-10h30v8h-30z" />
    <path fill="currentColor" d="m58 58h-34v-12h34zm-32-2h30v-8h-30z" />
  </svg>
);

export default IconWebPage;
